import { Project } from "./Project";
import { DAO } from "./DAO";
import { useEffect, useState } from "react";
import { OnApiError } from "../ErrorManager";
import { useAppContext } from "../../libs/app-core/AppContext";
import { new_ErrorAlert } from "../export_spwk/ExportManager";
import { API, ApiResult } from "./API";
import { WS_Public } from "./WS";
import dayjs from "dayjs";
import DateHelper from "../heplers/DateHelper";

export class ProjectDAO {

  /** 問卷場次編號(自訂但不重複的編號) */
  static async FetchByCID(cid: string): Promise<Project | null> {
    let cond = " WHERE (1=1) "
      + "AND " + Cnd.CID(cid);// 以場次CID編號

    let data_list = await DAO.Select(Project, cond);

    if (data_list.length === 1) {
      return data_list[0];
    } else if (data_list.length === 0) {
      return null;
    } else {
      throw new_ErrorAlert("重複的場次編號!!!");
    }
  }

  static async FetchByProjectCode(project_code: string): Promise<Project | null> {
    let cond = " WHERE (1=1) "
      + "AND " + Cnd.ProjectCode(project_code);// 以場次編號查詢

    let data_list = await DAO.Select(Project, cond);

    if (data_list.length === 1) {
      return data_list[0];
    } else if (data_list.length === 0) {
      return null;
    } else {
      throw new_ErrorAlert("重複的場次編號!!!");
    }
  }

  static async SelectAll(is_desc: boolean): Promise<Project[]> {
    let cond = " WHERE (1=1) "
      + Cnd.OrderBy_RecDT_Code(is_desc);

    let data_list = await DAO.Select(Project, cond);

    return data_list;
  }

  static async Select指定日期(str_dt: string, end_dt: string): Promise<Project[]> {
    let cond = " WHERE (1=1) " + " AND " + Cnd.指定日期(str_dt, end_dt) + " AND " + Cnd.排除共用場次() + Cnd.OrderBy_RecDT_Code(true);
    let data_list = await DAO.Select(Project, cond);
    return data_list;
  }

  static async FetchByGuid(guid: string): Promise<Project> {
    let data = await DAO.FetchByGuid(Project, guid);
    return data;
  }

  static async Insert(data: Project): Promise<Project> {
    let refetch_data = await DAO.Insert(Project, data);
    return refetch_data;
  }

  static async Update(data: Project): Promise<Project> {
    let refetch_data = await DAO.Update(Project, data);
    return refetch_data;
  }

  static async Delete(data: Project): Promise<number> {
    let effect_rows_cnt = await DAO.DeleteByGuid(Project, data.guid);
    return effect_rows_cnt;
  }

  static async WS_FetchByGuid(guid: string | null): Promise<Project | null> {
    let api_rslt: ApiResult = await WS_Public.CallPublicPost(
      "uni_project/select_by_guid",
      { guid: guid }
    );
    if (api_rslt.code === API.CODE_OK) {
      if (api_rslt.data.length === 1) {
        let project_list = API.ToClassList(Project, api_rslt.data);
        return project_list[0];
      } else if (api_rslt.data.length === 0) {
        return null;
        // throw new_ErrorAlert(`不應該沒資料 !!!`);
      } else {
        throw new_ErrorAlert("重複的場次編號!!!");
      }
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }
  static async Public_FetchCustInfoByCid(cid: string | null): Promise<project_data | null> {
    let api_rslt: ApiResult = await WS_Public.CallPublicPost(
      "uni_project/select_by_project_cid",
      { project_cid: cid }
    );
    if (api_rslt.code === API.CODE_OK) {
      if (api_rslt.data.length === 1) {
        let project_list = API.ToClassList(Project, api_rslt.data);
        let project = project_list[0];
        return {
          cust_name: project.cust_name,
          quest_start: project.quest_start,
          quest_end: project.quest_end,
          account_rule: project.account_rule,
          password_rule: project.password_rule,
        };
      } else if (api_rslt.data.length === 0) {
        return null;
        // throw new_ErrorAlert(`不應該沒資料 !!!`);
      } else {
        let project_list = API.ToClassList(Project, api_rslt.data);
        let project = project_list.find(x => x.project_code.startsWith("#"));
        if (project == null) {
          throw new_ErrorAlert("重複的場次編號!!!");
        }
        return {
          cust_name: project.cust_name,
          quest_start: project.quest_start,
          quest_end: project.quest_end,
          account_rule: project.account_rule,
          password_rule: project.password_rule,
        };
      }
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }
  static async Update_SetAccountRule(data: Project, AccountRule: '' | '生日' | '身分證' | '員工編號' | '姓名'): Promise<Project> {
    data.account_rule = AccountRule;
    let re = await DAO.UpdateOnly(Project, data, ["account_rule"]);
    return re;
  }
  static async Update_SetPassWord(data: Project, PasswordRule: '' | '生日' | '身分證' | '員工編號' | '姓名'): Promise<Project> {
    data.password_rule = PasswordRule;
    let re = await DAO.UpdateOnly(Project, data, ["password_rule"]);
    return re;
  }

  static async Update_SetStartDate(data: Project, StartDate: string): Promise<Project> {
    data.quest_start = StartDate;
    let re = await DAO.UpdateOnly(Project, data, ["quest_start"]);
    return re;
  }

  static async Update_SetEndDate(data: Project, EndDate: string): Promise<Project> {
    data.quest_end = EndDate;
    let re = await DAO.UpdateOnly(Project, data, ["quest_end"]);
    return re;
  }

  static async Update_SetCid(data: Project, Cid: string): Promise<Project> {
    data.cid = Cid;
    let re = await DAO.UpdateOnly(Project, data, ["cid"]);
    return re;
  }

  static async UpdateEndDtOnly(data: Project, nowTime: string) {
    data.end_dt = nowTime;
    await DAO.UpdateOnly(Project, data, ["end_dt"]);
  }

  static async Update_CommonDate(data: Project, CommonDate: string): Promise<Project> {
    data.common_date = dayjs(CommonDate).format('YYYY-MM-DD');
    let re = await DAO.UpdateOnly(Project, data, ["common_date"]);
    return re;
  }

}

class Cnd {
  static 指定日期(str_dt: string, end_dt: string) {
    try {
      let re = "";
      if (DateHelper.IsBlankDay(str_dt) && DateHelper.IsBlankDay(end_dt)) {
        //全撈
        re = `(1 = 1)`;
      } else if (DateHelper.IsBlankDay(end_dt)) {
        re = `(rec_dt >= "${str_dt}")`;
      } else if (DateHelper.IsBlankDay(str_dt)) {
        re = `( rec_dt <= "${end_dt}" )`;
      } else {
        re = `( rec_dt >= "${str_dt}" AND rec_dt <= "${end_dt}" )`;
      }
      return re;
    } catch (error) {
      throw new_ErrorAlert(`7678913 ${error}`);
    }
  }

  static 排除共用場次() {
    return "project_code not like '%#%'";
  }

  static OrderBy_RecDT_Code(is_desc: boolean) {
    if (is_desc) {
      return " ORDER BY rec_dt DESC, project_code DESC, serno DESC ";
    } else {
      return " ORDER BY rec_dt, project_code, serno ";
    }
  }

  static CID(cid: string) {
    return " (cid='" + cid + "') ";
  }


  static ProjectCode(project_code: string) {
    return " (project_code='" + project_code + "') ";
  }


}


export function useProject(guid: string) {
  const ctx = useAppContext();

  const [_Project, set_Project] = useState<Project | null>(null);

  async function refresh_Project() {
    try {
      const data_list = await ProjectDAO.FetchByGuid(guid);

      set_Project(data_list);

      // console.log(data_list);

    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_Project();
  }, [guid]);

  return { _Project, set_Project, refresh_Project }
}

export function UseProject_ws(guid: string | undefined) {
  const ctx = useAppContext();

  const [_Project, set_Project] = useState<Project | null | undefined>(undefined);

  async function refresh_Project() {
    try {
      if (guid === undefined) {
        set_Project(undefined);
        return;
      }

      const data_list = await ProjectDAO.WS_FetchByGuid(guid);

      set_Project(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_Project();
  }, [guid]);

  return { _Project, set_Project, refresh_Project }
}

export function useProjectList(is_desc: boolean) {
  const ctx = useAppContext();

  const [_ProjectList, set_ProjectList] = useState<Project[] | undefined>(undefined);// 尚未撈資料庫時為 undefined

  async function refresh_ProjectList() {
    try {
      const data_list = await ProjectDAO.SelectAll(is_desc);

      set_ProjectList(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_ProjectList();
  }, [is_desc]);

  return { _ProjectList, set_ProjectList, refresh_ProjectList }
}
export class project_data {
  cust_name = "";
  quest_end = '';
  quest_start = '';
  account_rule: '' | '生日' | '身分證' | '員工編號' | '姓名' = '';
  password_rule: '' | '生日' | '身分證' | '員工編號' | '姓名' = '';
}

